/* Presentation adapter only: Growave retains list, variant, save and cart logic. */
(() => {
  'use strict';
  const script = document.querySelector('script[data-wishlist-styles]');
  const page = document.querySelector('.adore-wishlist-page');
  if (!script || !page) return;
  const romanian = document.documentElement.lang.toLowerCase().startsWith('ro');
  const translations = new Map([
    ['Preț Major-Low', 'Preț descrescător'], ['Preț Low-High', 'Preț crescător'],
    ['In vanzare', 'La reducere'], ['Împărtășește', 'Distribuie'],
    ['Listă de dorințe', 'Listele mele'], ['Adăugați o listă nouă', 'Creează o listă'],
    ['Salvați', 'Salvează'], ['Anulare', 'Anulează'],
    ['Creați o listă', 'Creează o listă'], ['Numele listei de dorințe', 'Numele listei'],
    ['Close modal', 'Închide'],
    ['Edit wishlist name', 'Redenumește lista'], ['Product menu', 'Opțiuni produs'],
    ['Opens the Growave website in a new tab', 'Deschide site-ul Growave într-o filă nouă']
  ]);
  const localize = (root) => {
    if (!romanian) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      // Never rewrite customer list names, product names, form input or code.
      if (node.parentElement?.closest('style, script, textarea, input, .gw-wl-card, .gw-wl-title, .gw-wl-product-card__title-link')) continue;
      const replacement = translations.get(node.textContent.trim());
      if (replacement) node.textContent = node.textContent.replace(node.textContent.trim(), replacement);
    }
    root.querySelectorAll('[aria-label]').forEach((el) => {
      const value = el.getAttribute('aria-label');
      const replacement = translations.get(value) || (value.startsWith('Împărtășește') ? value.replace('Împărtășește', 'Distribuie') : null);
      if (replacement) el.setAttribute('aria-label', replacement);
    });
  };
  function refine(root) {
    if (!root.querySelector('[data-adore-wishlist-style]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = script.dataset.wishlistStyles;
      link.dataset.adoreWishlistStyle = '';
      root.append(link);
    }
    localize(root);
    root.querySelectorAll('.gw-wl-share').forEach((share) => {
      if (share.querySelector('.adore-share-toggle')) return;
      const list = share.querySelector('.gw-wl-share__list');
      if (!list) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'adore-share-toggle';
      button.textContent = romanian ? 'Distribuie' : 'Share';
      button.setAttribute('aria-expanded', 'false');
      if (!list.id) list.id = 'adore-share-options';
      button.setAttribute('aria-controls', list.id);
      const close = () => { share.classList.remove('adore-share-open'); button.setAttribute('aria-expanded', 'false'); };
      button.addEventListener('click', () => {
        const open = share.classList.toggle('adore-share-open');
        button.setAttribute('aria-expanded', String(open));
      });
      share.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { close(); button.focus(); }
      });
      share.addEventListener('focusout', (event) => { if (!share.contains(event.relatedTarget)) close(); });
      // A single root listener per share, disposed with the widget root.
      root.addEventListener('click', (event) => { if (!share.contains(event.target)) close(); });
      share.classList.add('adore-share-collapsible');
      share.prepend(button);
    });
  }
  let observedRoot;
  let rootObserver;
  function connect() {
    const root = page.querySelector('.gw-wl-page-placeholder')?.shadowRoot;
    if (!root || root === observedRoot) return;
    rootObserver?.disconnect();
    observedRoot = root;
    const update = () => {
      rootObserver.disconnect();
      refine(root);
      rootObserver.observe(root, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label']});
    };
    rootObserver = new MutationObserver(update);
    update();
  }
  // Growave attaches a shadow root asynchronously, which a light-DOM observer cannot see.
  let attempts = 0;
  const timer = setInterval(() => { connect(); if (observedRoot || ++attempts >= 120) clearInterval(timer); }, 250);
  const pageObserver = new MutationObserver(connect);
  pageObserver.observe(page, {childList: true, subtree: true});
  connect();
  // Growave renders create/edit dialogs outside its page shadow root.
  const modalObservers = new Map();
  const connectModals = () => {
    document.querySelectorAll('.gw-wl-edit-modal-widget-placeholder, .gw-wl-create-modal-widget-placeholder').forEach((host) => {
      const root = host.shadowRoot;
      if (!root || modalObservers.has(root)) return;
      const observer = new MutationObserver(() => {
        observer.disconnect();
        localize(root);
        observer.observe(root, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label']});
      });
      modalObservers.set(root, observer);
      localize(root);
      observer.observe(root, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label']});
    });
  };
  const modalHostObserver = new MutationObserver(connectModals);
  modalHostObserver.observe(document.body, {childList: true, subtree: true});
  connectModals();
  function placeHelp() {
    const whatsapp = document.querySelector('a.custom-whatsapp');
    if (!whatsapp || page.querySelector('.adore-wishlist-help')) return;
    const help = document.createElement('aside');
    help.className = 'adore-wishlist-help';
    const text = document.createElement('p');
    text.textContent = romanian ? 'Ai nevoie de ajutor să alegi?' : 'Need help choosing?';
    const label = document.createElement('span');
    label.className = 'adore-wishlist-help__label';
    label.textContent = 'WhatsApp';
    whatsapp.append(label);
    help.append(text, whatsapp);
    page.append(help);
  }
  // Deferred script runs after the DOM is parsed. Do not wait for third-party
  // videos/images to finish loading before removing the floating obstruction.
  placeHelp();
  window.addEventListener('load', placeHelp, {once: true});
  window.addEventListener('pagehide', () => {
    clearInterval(timer); pageObserver.disconnect(); rootObserver?.disconnect();
    modalHostObserver.disconnect(); modalObservers.forEach((observer) => observer.disconnect()); modalObservers.clear();
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      observedRoot = null; connect(); pageObserver.observe(page, {childList: true, subtree: true});
      connectModals(); modalHostObserver.observe(document.body, {childList: true, subtree: true});
    }
  });
})();
